import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import MovieIcon from '@mui/icons-material/Movie';
import Stack from '@mui/material/Stack';

function Watchlists() {
  const [listData, setListData] = useState<any[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    fetch('/watchlists')
      .then((resp) => {
        if (!resp.ok) {
          throw new Error('Unable to load watchlists');
        }
        return resp.json();
      })
      .then((data) => {
        if (isMounted) {
          setListData(data || []);
        }
      })
      .catch(() => {
        if (isMounted) {
          setError('Unable to load watchlists');
          setListData([]);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  function updatelistAPI(id) {
    const url = "/watchlists/" + id;
    return fetch(url, { method: 'DELETE' }).then((resp) => {
      if (!resp.ok) {
        throw new Error('Unable to remove watchlist');
      }
      return resp.json();
    });
  }

  function updateList(e, item) {
    e.preventDefault();
    const list = (listData || []).filter(i => i.id !== item.id);
    updatelistAPI(item.id).catch(() => {
      // Ignore errors for now; UI already optimistic.
    });
    return setListData(list);
  }

  if (!listData) {
    return (
      <div className="table-responsive border-bottom">
        <div className="py-4">Loading watchlists...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="table-responsive border-bottom">
        <div className="py-4">{error}</div>
      </div>
    );
  }

  if (listData.length === 0) {
    return (
      <div className="table-responsive border-bottom">
        <div className="py-4">
          <p>You have no watchlists yet.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive border-bottom">
          <table className="table table-striped table-sm">
            <tbody>
          { listData.map((item =>
            <tr key={item.id}>
              <td>{item.name}</td>
              <td>
                <form>
                  <Stack direction="row" spacing={2}>
                    <Button href={"/watchlists/" + item.id} size="small" variant="outlined" startIcon={<MovieIcon />}>View</Button>
                    <Button size="small" onClick={(e) => updateList(e, item) } variant="outlined" startIcon={<DeleteIcon />}>Delete</Button>
                  </Stack>
                </form>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Watchlists;
